import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useCreateAccessGrant } from "@/hooks/use-access";
import { AccessGrantForm } from "./AccessGrantForm";

export function AddPersonDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const create = useCreateAccessGrant();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Add person</DialogTitle>
          <DialogDescription>
            They sign in with their Microsoft work account. Nothing is sent to them.
          </DialogDescription>
        </DialogHeader>
        {open && (
          <AccessGrantForm
            submitLabel="Add person"
            isSaving={create.isPending}
            onCancel={() => onOpenChange(false)}
            onSubmit={(values) =>
              create.mutate(
                { email: values.email, level: values.level, title: values.title || null },
                { onSuccess: () => onOpenChange(false) },
              )
            }
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
